import axios from '../axios';
// 付款单位列表
export const getBasePayeePage = data => {
  return axios({
    url: '/api/sys/base/getBasePayeePage',
    method: 'post',
    data
  })
};
// 付款单位列表 保存
export const saveBasePayee = data => {
    return axios({
      url: '/api/sys/base/saveBasePayee',
      method: 'post',
      data
  })
};
// 付款单位列表 修改
export const updateBasePayee = data => {
    return axios({
      url: '/api/sys/base/updateBasePayee',
      method: 'post',
      data
  })
};
// 付款单位列表 删除
export const deleteBasePayees = data => {
    return axios({
      url: '/api/sys/base/deleteBasePayees',
      method: 'post',
      data
  })
};
// 付款单位列表 禁用
export const forbidBasePayees = data => {
    return axios({
      url: '/api/sys/base/forbidBasePayees',
      method: 'post',
      data
  })
};
// 收货单位列表
export const getBaseRecipientPage = data => {
  return axios({
    url: '/api/sys/base/recipient/getBaseRecipientPage',
    method: 'post',
    data
  })
};
// 收货单位列表新增
export const saveBaseRecipient = data => {
  return axios({
    url: '/api/sys/base/recipient/saveBaseRecipient',
    method: 'post',
    data
  })
};
// 收货单位列表修改
export const updateBaseRecipient = data => {
  return axios({
    url: '/api/sys/base/recipient/updateBaseRecipient',
    method: 'post',
    data
  })
};
// 收货单位列表删除
export const deleteBaseRecipients = data => {
  return axios({
    url: '/api/sys/base/recipient/deleteBaseRecipients',
    method: 'post',
    data
  })
};
// 收货单位列表禁用
export const forbidBaseRecipients = data => {
  return axios({
    url: '/api/sys/base/recipient/forbidBaseRecipients',
    method: 'post',
    data
  })
};
// 收支项目列表
export const getFinIncomeExpensePage = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpensePage',
    method: 'post',
    data
  })
};
// 收支项目列表 保存
export const saveFinIncomeExpense = data => {
  return axios({
    url: '/api/sys/fin/saveFinIncomeExpense',
    method: 'post',
    data
  })
};
// 收支项目列表 修改
export const updateFinIncomeExpense = data => {
  return axios({
    url: '/api/sys/fin/updateFinIncomeExpense',
    method: 'post',
    data
  })
};
// 收支项目列表 删除
export const deleteFinIncomeExpenses = data => {
  return axios({
    url: '/api/sys/fin/deleteFinIncomeExpenses',
    method: 'post',
    data
  })
};
// 收支项目列表 禁用 forbidStatus 1已禁用 0未禁用/启用
export const forbidFinIncomeExpenses = data => {
  return axios({
    url: '/api/sys/fin/forbidFinIncomeExpenses',
    method: 'post',
    data
  })
};
// 收支清单列表
export const getFinIncomeExpenseBillPage = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpenseBillPage',
    method: 'post',
    data
  })
};
// 收支清单列表
export const getFinIncomeExpenseBillPageOfHavePermission = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpenseBillPageOfHavePermission',
    method: 'post',
    data
  })
};
// 收支清单列表 保存
export const saveFinIncomeExpenseBill = data => {
  return axios({
    url: '/api/sys/fin/saveFinIncomeExpenseBill',
    method: 'post',
    data
  })
};
// 收支清单列表 修改
export const updateFinIncomeExpenseBill = data => {
  return axios({
    url: '/api/sys/fin/updateFinIncomeExpenseBill',
    method: 'post',
    data
  })
};
// 收支清单列表 删除
export const deleteFinIncomeExpenseBills = data => {
  return axios({
    url: '/api/sys/fin/deleteFinIncomeExpenseBills',
    method: 'post',
    data
  })
};
// 收支清单列表 作废
export const cancelFinIncomeExpenseBills = data => {
  return axios({
    url: '/api/sys/fin/cancelFinIncomeExpenseBills',
    method: 'post',
    data
  })
};
// 收支清单列表 审核 一审 
export const auditFinIncomeExpenseBillsOfFirst = data => {
  return axios({
    url: '/api/sys/fin/auditFinIncomeExpenseBillsOfFirst',
    method: 'post',
    data
  })
};
// 收支清单列表 审核  二审  
export const auditFinIncomeExpenseBillsOfSecond = data => {
  return axios({
    url: '/api/sys/fin/auditFinIncomeExpenseBillsOfSecond',
    method: 'post',
    data
  })
};
// 收支清单列表 反审 一审 
export const unAuditFinIncomeExpenseBillsOfFirst = data => {
  return axios({
    url: '/api/sys/fin/unAuditFinIncomeExpenseBillsOfFirst',
    method: 'post',
    data
  })
};
// 收支预设列表  
export const getFinIncomeExpensePresetPage = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpensePresetPage',
    method: 'post',
    data
  })
}; 
// 收支预设列表   保存
export const saveFinIncomeExpensePreset = data => {
  return axios({
    url: '/api/sys/fin/saveFinIncomeExpensePreset',
    method: 'post',
    data
  })
};
// 收支预设列表   修改
export const updateFinIncomeExpensePreset = data => {
  return axios({
    url: '/api/sys/fin/updateFinIncomeExpensePreset',
    method: 'post',
    data
  })
};
// 收支预设列表   删除
export const deleteFinIncomeExpensePresets = data => {
  return axios({
    url: '/api/sys/fin/deleteFinIncomeExpensePresets',
    method: 'post',
    data
  })
};
// 收支预设列表   作废
export const cancelFinIncomeExpensePresets = data => {
  return axios({
    url: '/api/sys/fin/cancelFinIncomeExpensePresets',
    method: 'post',
    data
  })
};
// 收支预设列表   审核
export const auditFinIncomeExpensePresets = data => {
  return axios({
    url: '/api/sys/fin/auditFinIncomeExpensePresets',
    method: 'post',
    data
  })
};
// 收支预设列表   反审核
export const unAuditFinIncomeExpensePresets = data => {
  return axios({
    url: '/api/sys/fin/unAuditFinIncomeExpensePresets',
    method: 'post',
    data
  })
};
// 付款通知/催款记录列表
export const getFinPaymentNoticePage = data => {
  return axios({
    url: '/api/sys/fin/getFinPaymentNoticePage',
    method: 'post',
    data
  })
};
// 保存催款并反写收支清单下次日期
export const saveFinPaymentNotice = data => {
  return axios({
    url: '/api/sys/fin/saveFinPaymentNotice',
    method: 'post',
    data
  })
};
// 修改来源是租赁合同单的收支清单
export const updateEqLeaseContractAndExpenseBill = data => {
  return axios({
    url: '/api/sys/eq/updateEqLeaseContractAndExpenseBill',
    method: 'post',
    data
  })
};
// 修改来源是工单的收支清单
export const updateEqWorkOrderAndExpenseBill = data => {
  return axios({
    url: '/api/sys/eq/updateEqWorkOrderAndExpenseBill',
    method: 'post',
    data
  })
};
// 查报销支出明细
export const getFinIncomeExpenseBillPageByFiltered = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpenseBillPageByFiltered',
    method: 'post',
    data
  })
};
// 查报销支出明细
export const getFinIncomeExpenseBillReimbursePage = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpenseBillReimbursePage',
    method: 'post',
    data
  })
};
// 保存费用报销单
export const saveFinIncomeExpenseBillAndReimburse = data => {
  return axios({
    url: '/api/sys/fin/saveFinIncomeExpenseBillAndReimburse',
    method: 'post',
    data
  })
};
// 修改费用报销单
export const updateFinIncomeExpenseBillAndReimburse = data => {
  return axios({
    url: '/api/sys/fin/updateFinIncomeExpenseBillAndReimburse',
    method: 'post',
    data
  })
};
// 修改来源是租赁结算单的收支清单
export const updateEqLeaseSettleAndExpenseBill = data => {
  return axios({
    url: '/api/sys/eq/updateEqLeaseSettleAndExpenseBill',
    method: 'post',
    data
  })
};
// 修改来源是租赁结算单的收支清单
export const getFinIncomeExpenseBillLogPage = data => {
  return axios({
    url: '/api/sys/fin/getFinIncomeExpenseBillLogPage',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Pay.js